/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	WhatsAppEmbeddedSignupResetSignupPathParams,
	WhatsAppEmbeddedSignupResetSignupResponse,
} from '../types/WhatsAppEmbeddedSignupResetSignup'

/**
 * POST /organisations/:organisationId/whatsapp-account/signup/reset
 * @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppEmbeddedSignupController.php WhatsAppEmbeddedSignupController::resetSignup
 */
export async function whatsAppEmbeddedSignupResetSignup(
	organisationId: WhatsAppEmbeddedSignupResetSignupPathParams['organisationId'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<WhatsAppEmbeddedSignupResetSignupResponse>> {
	return axiosInstance.post(`/organisations/${organisationId}/whatsapp-account/signup/reset`, undefined, config)
}
